const BugsnagErrorBoundaryWrapper__Fallback = () => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
        }}
    >
        <h1
            style={{
                textAlign: "center",
                fontSize: "3rem",
                fontWeight: "bold",
            }}
        >
            Es ist ein Fehler aufgetreten
        </h1>
        <p style={{ textAlign: "center", fontSize: "1.5rem" }}>
            Bitte laden Sie die Seite neu. Wir bitten um Verständnis.
        </p>
        <button
            type="button"
            onClick={() => {
                window.location.href = "/dashboard";
            }}
            aria-label="Seite neu laden"
            style={{
                textAlign: "center",
                fontSize: "1rem",
                padding: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
                backgroundColor: "#d4d4d8",
                width: "fit-content",
                borderRadius: "10px",
                marginTop: "20px",
            }}
        >
            Seite neu laden
        </button>
    </div>
);

export { BugsnagErrorBoundaryWrapper__Fallback };
